module.exports = __webpack_public_path__ + "img/014.6ff16a61.jpg";